(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const behavior = () => reduced.matches ? 'instant' : 'smooth';
  const qs = (s, r = document) => r.querySelector(s);
  const all = (s, r = document) => [...r.querySelectorAll(s)];
  const openDialog = (dialog, trigger, hover = false) => {
    if (!dialog) return;
    if (dialog._closing) {clearTimeout(dialog._closeTimer);dialog._resolveClose?.();dialog._closing=null;}
    dialog._trigger = trigger;
    const desktop=dialog.matches('.rd-menu')&&matchMedia('(min-width:990px)').matches;
    if (!dialog.open) {
      if(desktop){dialog.setAttribute('open','');dialog._setMenuState?.(true);if(!hover)qs('button,a[href]',dialog)?.focus({preventScroll:true});}
      else dialog.showModal();
    }
    all('[data-rd-menu-open]',dialog.closest('[data-rd-header]')||document).forEach(button=>button.setAttribute('aria-expanded',String(button===trigger)));
    requestAnimationFrame(() => requestAnimationFrame(() => {if (dialog.open) dialog.classList.add('is-visible');}));
    trigger?.setAttribute('aria-expanded', 'true');
  };
  const closeDialog = (dialog, restoreFocus = true) => {
    if (!dialog?.open) return Promise.resolve();
    if (dialog._closing) return dialog._closing;
    dialog.classList.remove('is-visible');
    dialog._closing = new Promise(resolve => {
      const finish = () => {
        dialog.close();
        dialog._trigger?.setAttribute('aria-expanded', 'false');
        if (restoreFocus) dialog._trigger?.focus({preventScroll:true});
        dialog._closing = null;
        resolve();
      };
      dialog._resolveClose=resolve;
      dialog._closeTimer=setTimeout(finish, reduced.matches ? 0 : 250);
    });
    return dialog._closing;
  };
  let nativeSearch;
  function topbarDeadline(settings) {
    const year = Number(settings.year), month = Number(settings.month), day = Number(settings.day);
    const hour = Number(settings.hour), minute = Number(settings.minute);
    if (![year, month, day, hour, minute].every(Number.isInteger) || year < 2020 || year > 2200 || month < 1 || month > 12 || day < 1 || day > 31 || hour < 0 || hour > 23 || minute < 0 || minute > 59) return NaN;
    const target = Date.UTC(year, month - 1, day, hour, minute, 59);
    const date = new Date(target);
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return NaN;
    try {
      const formatter = new Intl.DateTimeFormat('en-GB', {timeZone: settings.timezone || 'Europe/Ljubljana', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'});
      let epoch = target;
      for (let i = 0; i < 4; i++) {
        const p = Object.fromEntries(formatter.formatToParts(epoch).map(part => [part.type, part.value]));
        const local = Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day), Number(p.hour), Number(p.minute), Number(p.second));
        if (local === target) return epoch;
        epoch += target - local;
      }
    } catch {}
    return NaN;
  }
  function countdownRemaining(deadline, now, labels) {
    const seconds = Math.max(0, Math.ceil((deadline - now) / 1000));
    const values = [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
    const units = [values[0] === 1 ? labels.dayLabel : labels.daysLabel, labels.hoursLabel, labels.minutesLabel, 's'];
    const first = values.findIndex(value => value > 0);
    return values.slice(first < 0 ? 3 : first).map((value, index) => `${value} ${units[(first < 0 ? 3 : first) + index]}`).join(' ');
  }
  function initTopbars(root = document) {
    all('[data-rd-topbar]', root).forEach(el => {
      if (el.dataset.ready) return;
      el.dataset.ready = 'true';
      const items = all('[data-topbar-item]', el).map(node => {
        const settings = JSON.parse(qs('[data-topbar-settings]', node).textContent);
        return {node, settings, kind: node.dataset.kind, text: qs('[data-topbar-text]', node), time: qs('[data-topbar-time]', node), deadline: node.dataset.kind === 'topbar_countdown' ? topbarDeadline(settings) : NaN};
      });
      const button = qs('[data-rd-motion-toggle]', el);
      const interval = Math.max(5, Number(el.dataset.interval) || 7) * 1000;
      const threshold = Number(el.dataset.threshold);
      const formatMoney = new Intl.NumberFormat(document.documentElement.lang || 'sl-SI', {style: 'currency', currency: el.dataset.currency || 'EUR'});
      const formatThreshold = new Intl.NumberFormat(document.documentElement.lang || 'sl-SI', {style: 'currency', currency: el.dataset.currency || 'EUR', minimumFractionDigits: threshold % 100 ? 2 : 0});
      let cart = {total_price: Number(el.dataset.total), item_count: Number(el.dataset.count), currency: el.dataset.currency};
      let available = [], current, paused = false, visible = false, hovered = false, focused = false, selected = null;
      let rotation, transition, clock, destroyed = false, fetching = false, revision = 0;
      const controller = new AbortController();
      const listen = (target, type, callback) => target.addEventListener(type, callback, {signal: controller.signal});
      const canRotate = () => !destroyed && visible && !document.hidden && !paused && !hovered && !focused && !selected && available.length > 1;
      const cancelRotation = () => { clearTimeout(rotation); clearTimeout(transition); };
      const show = item => {
        current = item;
        items.forEach(entry => {
          const active = entry === item;
          entry.node.classList.toggle('is-active', active);
          entry.node.inert = !active;
          entry.node.setAttribute('aria-hidden', String(!active));
          const link = qs('a', entry.node);
          if (link) link.tabIndex = active ? 0 : -1;
        });
      };
      const schedule = (extra = 0) => {
        clearTimeout(rotation);
        if (!canRotate()) return;
        rotation = setTimeout(() => {
          if (!canRotate()) return;
          const next = available[(available.indexOf(current) + 1) % available.length];
          current?.node.classList.remove('is-active');
          const duration = reduced.matches ? 0 : 220;
          transition = setTimeout(() => {
            // A deadline may pass while the outgoing message is fading out.
            refresh();
            if (available.includes(next)) { show(next); schedule(duration); }
          }, duration);
        }, interval + extra);
      };
      const refresh = () => {
        const now = Date.now();
        const dynamic = [], fallback = [];
        // Akcija z vklopljenim »Skrij po koncu odštevalnika« izgine skupaj z iztečenim odštevalnikom.
        const countdownEnded = items.some(item => item.kind === 'topbar_countdown' && item.settings.enabled !== false && Number.isFinite(item.deadline) && item.deadline <= now);
        items.forEach(item => {
          if (item.settings.enabled === false) return;
          if (item.kind === 'topbar_shipping') {
            if (cart.currency !== 'EUR' || !(threshold > 0)) return;
            const remaining = Math.max(0, threshold - Math.max(0, cart.total_price));
            const template = cart.item_count === 0 ? item.settings.text_empty : remaining > 0 ? item.settings.text_remaining : item.settings.text_earned;
            item.text.textContent = (template || '').replaceAll('{prag}', formatThreshold.format(threshold / 100)).replaceAll('{znesek}', formatMoney.format(remaining / 100));
            if (item.text.textContent.trim()) dynamic.push(item);
          } else if (item.kind === 'topbar_countdown') {
            if (!Number.isFinite(item.deadline) || item.deadline <= now) return;
            item.time.textContent = countdownRemaining(item.deadline, now, el.dataset);
            item.time.dateTime = new Date(item.deadline).toISOString();
            dynamic.push(item);
          } else if (item.kind === 'topbar_promotion' && item.settings.hide_after_countdown !== false && countdownEnded) {
            return;
          } else if ((item.settings.text || '').trim()) {
            (item.kind === 'announcement' ? fallback : dynamic).push(item);
          }
        });
        let next = dynamic.length ? dynamic : el.dataset.fallback !== 'false' ? fallback : [];
        const preview = selected && [...dynamic, ...fallback].find(item => item.node.dataset.blockId === selected);
        if (preview) next = [preview];
        if (next.length !== available.length || next.some((item, index) => item !== available[index])) {
          cancelRotation(); available = next;
          items.forEach(item => { item.node.hidden = !available.includes(item); });
          el.hidden = available.length === 0;
          show(available.includes(current) ? current : available[0]);
          schedule();
        }
        if (!available.length) el.hidden = true;
        button.hidden = available.length < 2;
        button.dataset.paused = String(paused);
        button.setAttribute('aria-label', button.dataset[paused ? 'playLabel' : 'pauseLabel']);
      };
      const tick = () => {
        clearTimeout(clock);
        refresh();
        const now = Date.now();
        const deadlines = items.filter(item => item.settings.enabled !== false && item.deadline > now).map(item => item.deadline);
        if (visible && !document.hidden && deadlines.length) {
          // Hide at the deadline itself, even if it falls before the next clock tick.
          clock = setTimeout(tick, Math.min(1000 - now % 1000 + 10, Math.min(...deadlines) - now));
        }
      };
      const sync = () => { cancelRotation(); tick(); show(current); schedule(); };
      el._updateCart = value => {
        if (!Number.isFinite(value?.total_price) || !Number.isFinite(value?.item_count)) return;
        revision++;
        cart = {...cart, ...value};
        tick();
        if (current?.kind === 'topbar_shipping') schedule();
      };
      const refreshCart = async () => {
        if (fetching || !items.some(item => item.kind === 'topbar_shipping' && item.settings.enabled !== false)) return;
        fetching = true;
        const started = revision;
        try {
          const response = await fetch(el.dataset.cartUrl, {credentials: 'same-origin', cache: 'no-store', signal: controller.signal});
          if (response.ok) {
            const value = await response.json();
            if (!destroyed && revision === started) el._updateCart(value);
          }
        } catch {} finally { fetching = false; }
      };
      listen(button, 'click', () => { paused = !paused; sync(); });
      listen(el, 'pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; sync(); } });
      listen(el, 'pointerleave', () => { hovered = false; sync(); });
      listen(el, 'focusin', () => { focused = true; sync(); });
      listen(el, 'focusout', event => { if (!el.contains(event.relatedTarget)) { focused = false; sync(); } });
      listen(document, 'visibilitychange', () => { sync(); if (!document.hidden) refreshCart(); });
      listen(window, 'pageshow', event => { sync(); if (event.persisted) refreshCart(); });
      listen(reduced, 'change', sync);
      listen(document, 'shopify:block:select', event => { if (el.contains(event.target)) { selected = event.detail.blockId; sync(); } });
      listen(document, 'shopify:block:deselect', () => { if (selected) { selected = null; sync(); } });
      const intersection = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); });
      intersection.observe(el);
      el._cleanup = () => { destroyed = true; cancelRotation(); clearTimeout(clock); controller.abort(); intersection.disconnect(); delete el._updateCart; };
      refresh();
    });
  }
  function initHeader(root = document) {
    if (window.theme?.settings.cartType === 'drawer' && qs('#CartDrawer') && window.theme.CartDrawer) new theme.CartDrawer();
    all('[data-rd-header]', root).forEach(header => {
      if (header.dataset.ready) return;
      header.dataset.ready = 'true';
      header.closest('.shopify-section')?.classList.add('rd-header-section');
      if (qs('#SearchModal') && window.theme?.Modals && !nativeSearch) {
        nativeSearch = new theme.Modals('SearchModal', 'rd-native-search', {closeOffContentClick:false, focusIdOnOpen:'SearchModalInput'});
        document.addEventListener('modalClose.SearchModal', () => {
          all('[data-rd-search-open]').forEach(button => button.setAttribute('aria-expanded','false'));
          nativeSearch._trigger?.focus({preventScroll:true});
        });
      }
      const measure = () => {
        const bounds = header.getBoundingClientRect();
        document.documentElement.style.setProperty('--rd-header', `${Math.max(0,bounds.bottom)}px`);
        document.documentElement.style.setProperty('--rd-header-size', `${bounds.height}px`);
        document.documentElement.style.setProperty('--rd-announcement-height', `${qs('[data-rd-announcement]',header)?.getBoundingClientRect().height || 0}px`);
        header.classList.toggle('is-scrolled', window.scrollY > 40);
      };
      header._resize = new ResizeObserver(measure);header._resize.observe(header);
      let frame;
      header._onScroll = () => {if (!frame) frame=requestAnimationFrame(()=>{measure();frame=null;});};
      window.addEventListener('scroll', header._onScroll, {passive:true});
      all('dialog', header).forEach(dialog => {
        dialog.addEventListener('cancel', e => {e.preventDefault();closeDialog(dialog);});
        dialog.addEventListener('click', e => { if (e.target === dialog) {const b = dialog.getBoundingClientRect(); if (e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom) closeDialog(dialog); }});
        dialog.addEventListener('close', () => all('[data-rd-menu-open]', header).forEach(b => b.setAttribute('aria-expanded', 'false')));
      });
      const menu=qs('.rd-menu',header),bar=qs('.rd-header__bar',header),desktop=matchMedia('(min-width:990px)'),fine=matchMedia('(hover:hover) and (pointer:fine)');
      let openTimer,closeTimer;
      const background=all('main,.site-footer');
      menu._setMenuState=open=>background.forEach(el=>{if(open){if(el._rdInert===undefined)el._rdInert=el.inert;el.inert=true;}else if(el._rdInert!==undefined){el.inert=el._rdInert;delete el._rdInert;}});
      menu.addEventListener('close',()=>menu._setMenuState(false));
      const cancelClose=()=>clearTimeout(closeTimer);
      const scheduleClose=()=>{clearTimeout(openTimer);cancelClose();if(desktop.matches)closeTimer=setTimeout(()=>closeDialog(menu,false),180);};
      all('.rd-header__desktop [data-rd-menu-open]',header).forEach(button=>{
        button.addEventListener('pointerenter',()=>{if(!desktop.matches||!fine.matches)return;cancelClose();clearTimeout(openTimer);openTimer=setTimeout(()=>{all('[data-rd-menu-category]',menu).forEach(x=>x.open=x.dataset.rdMenuCategory===button.dataset.rdCategory);openDialog(menu,button,true);},110);});
        button.addEventListener('pointerleave',()=>clearTimeout(openTimer));
        button.addEventListener('keydown',e=>{if(e.key==='ArrowDown'){e.preventDefault();clearTimeout(openTimer);cancelClose();all('[data-rd-menu-category]',menu).forEach(x=>x.open=x.dataset.rdMenuCategory===button.dataset.rdCategory);openDialog(menu,button);qs('.rd-menu__links details[open] a',menu)?.focus();}});
      });
      bar.addEventListener('pointerenter',cancelClose);menu.addEventListener('pointerenter',cancelClose);
      header.addEventListener('pointerleave',scheduleClose);
      all('.rd-header__desktop>a:not([data-rd-menu-open]),.rd-header__actions,.rd-header__logo',header).forEach(el=>el.addEventListener('pointerenter',scheduleClose));
      const backdrop=qs('[data-rd-menu-backdrop]',header);
      backdrop.addEventListener('pointerenter',scheduleClose);backdrop.addEventListener('click',()=>closeDialog(menu));
      header.addEventListener('keydown',e=>{if(e.key==='Escape'&&menu.open){e.preventDefault();closeDialog(menu);}});
      const onBreakpoint=()=>{clearTimeout(openTimer);cancelClose();if(menu.open){clearTimeout(menu._closeTimer);menu.close();menu._resolveClose?.();menu._closing=null;menu.classList.remove('is-visible');}};
      desktop.addEventListener('change',onBreakpoint);
      const cleanupStories=initMenuStories(menu);
      header._cleanup=()=>{clearTimeout(openTimer);cancelClose();cancelAnimationFrame(frame);menu._setMenuState(false);desktop.removeEventListener('change',onBreakpoint);cleanupStories();};
      measure();
    });
  }
  function initCategoryPress() {
    const selector = '.rd-menu__promo-link,.rd-collection__link,.rd-menu__product,.rd-menu__catalog-cta';
    let pending, pressed;
    const reset = () => {
      clearTimeout(pending);
      pressed?.classList.remove('is-pressed');
      pressed = null;
    };
    document.addEventListener('click', event => {
      const link = event.target.closest?.(selector);
      // Keep keyboard activation, new tabs, downloads and editor selection native.
      if (!link || event.defaultPrevented || event.button !== 0 || event.detail === 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self') || window.Shopify?.designMode) return;
      const touch = event.pointerType === 'touch' || event.pointerType === 'pen' || matchMedia('(max-width:989px), (hover:none) and (pointer:coarse)').matches;
      if (!touch || reduced.matches) return;
      const destination = new URL(link.href, location.href);
      if (!/^https?:$/.test(destination.protocol) || destination.origin !== location.origin || (destination.pathname === location.pathname && destination.search === location.search && destination.hash)) return;
      const card = link.closest('.rd-menu__promo,.rd-collection,.rd-menu__product,.rd-menu__catalog-cta');
      if (!card) return;
      // Commit only on click: scrolling or swiping must never start navigation.
      event.preventDefault();
      reset();
      pressed = card;
      card.classList.add('is-pressed');
      pending = setTimeout(() => {
        if (link.isConnected) location.assign(destination.href);
        else reset();
      }, 200);
    });
    window.addEventListener('pagehide', reset);
    window.addEventListener('pageshow', reset);
    document.addEventListener('shopify:section:unload', event => {
      if (pressed && event.target.contains(pressed)) reset();
    });
  }
  function initHeroes(root = document) {
    all('.rd-hero', root).forEach(hero => {
      if (hero.dataset.rdHeroReady) return;
      hero.dataset.rdHeroReady = 'true';
      const viewport = window.visualViewport;
      const mobile = matchMedia('(max-width:989px), (hover:none) and (pointer:coarse)');
      let width = 0, frame;
      const measure = () => {
        frame = null;
        // Ignore the on-screen keyboard and pinch zoom: neither changes the page layout.
        if (viewport && Math.abs(viewport.scale - 1) > .01) return;
        if (document.activeElement?.matches('input,textarea,[contenteditable="true"]')) return;
        // Mobile chrome can resize BEFORE scrollY updates, and during overscroll at 0.
        // Keep the initial pixel height for this width, including after returning to top.
        // A real width/orientation change is the only mobile layout resize we follow.
        if (width === innerWidth && mobile.matches) return;
        const height = Math.round(viewport?.height || innerHeight);
        if (height <= 0) return;
        const headerHeight = qs('[data-rd-header]')?.getBoundingClientRect().height || 0;
        width = innerWidth;
        // Snapshot the final hero height, not a live subtraction from a sticky header.
        hero.style.setProperty('--rd-hero-height', `${Math.max(0, height - headerHeight)}px`);
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(measure); };
      window.addEventListener('resize', schedule, {passive: true});
      viewport?.addEventListener('resize', schedule, {passive: true});
      document.addEventListener('focusout', schedule);
      hero._cleanup = () => {
        cancelAnimationFrame(frame);
        window.removeEventListener('resize', schedule);
        viewport?.removeEventListener('resize', schedule);
        document.removeEventListener('focusout', schedule);
      };
      measure();
    });
  }
  function initMenuStories(menu) {
    const track=qs('.rd-menu__promos',menu),cards=all('.rd-menu__promo',track),buttons=all('[data-rd-motion-toggle]',track);
    if(cards.length<2){buttons.forEach(button=>button.hidden=true);return ()=>{};}
    const mobile=matchMedia('(max-width:989px)');
    const fills=cards.map(card=>{
      const progress=document.createElement('div');progress.className='rd-menu__progress';progress.setAttribute('aria-hidden','true');
      const items=cards.map(()=>{const segment=document.createElement('span'),fill=document.createElement('i');segment.append(fill);progress.append(segment);return fill;});
      card.append(progress);return items;
    });
    let index=0,animations=[],paused=false,pressed=false,scrolling=false,visible=false,settleTimer;
    const active=()=>mobile.matches&&menu.open&&menu.classList.contains('is-visible')&&visible&&!document.hidden&&!reduced.matches&&!paused&&!pressed&&!scrolling&&(!track.matches(':focus-within')||buttons.includes(document.activeElement));
    const sync=()=>{
      const running=active();animations.forEach(animation=>running?animation.play():animation.pause());
      buttons.forEach(button=>{button.dataset.paused=String(paused);button.setAttribute('aria-label',button.dataset[paused?'playLabel':'pauseLabel']);});
    };
    const reset=()=>{
      animations.forEach(animation=>{animation.onfinish=null;animation.cancel();});
      fills.forEach(row=>row.forEach((fill,i)=>fill.style.transform=`scaleX(${i<index?1:0})`));
      animations=fills.map(row=>{const animation=row[index].animate([{transform:'scaleX(0)'},{transform:'scaleX(1)'}],{duration:6000,easing:'linear',fill:'forwards'});animation.pause();return animation;});
      animations[0].onfinish=()=>{
        index=(index+1)%cards.length;scrolling=true;reset();
        const left=track.scrollLeft+cards[index].getBoundingClientRect().left-track.getBoundingClientRect().left;
        track.scrollTo({left,behavior:behavior()});
        clearTimeout(settleTimer);settleTimer=setTimeout(settled,160);
      };
      sync();
    };
    const settled=()=>{
      clearTimeout(settleTimer);scrolling=false;
      const left=track.getBoundingClientRect().left;
      const nearest=cards.reduce((best,card,i)=>Math.abs(card.getBoundingClientRect().left-left)<Math.abs(cards[best].getBoundingClientRect().left-left)?i:best,0);
      if(nearest!==index){index=nearest;reset();}else sync();
    };
    const onScroll=()=>{scrolling=true;sync();clearTimeout(settleTimer);settleTimer=setTimeout(settled,160);};
    const release=()=>{pressed=false;sync();};
    track.addEventListener('scroll',onScroll,{passive:true});
    track.addEventListener('scrollend',settled);
    track.addEventListener('pointerdown',()=>{pressed=true;sync();},{passive:true});
    window.addEventListener('pointerup',release);window.addEventListener('pointercancel',release);
    track.addEventListener('focusin',sync);track.addEventListener('focusout',()=>requestAnimationFrame(sync));
    buttons.forEach(button=>button.addEventListener('click',()=>{paused=!paused;sync();}));
    const mutation=new MutationObserver(sync);mutation.observe(menu,{attributes:true,attributeFilter:['open','class']});
    const intersection=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:.35});intersection.observe(track);
    document.addEventListener('visibilitychange',sync);reduced.addEventListener('change',sync);mobile.addEventListener('change',sync);
    reset();
    return ()=>{animations.forEach(animation=>animation.cancel());clearTimeout(settleTimer);mutation.disconnect();intersection.disconnect();document.removeEventListener('visibilitychange',sync);reduced.removeEventListener('change',sync);mobile.removeEventListener('change',sync);window.removeEventListener('pointerup',release);window.removeEventListener('pointercancel',release);};
  }
  function initMarquees(root=document){
    all('[data-rd-marquee]',root).forEach(viewport=>{
      if(viewport.dataset.ready)return;viewport.dataset.ready='true';
      const group=qs('[data-rd-marquee-group]',viewport),track=qs('[data-rd-marquee-track]',viewport),button=qs('[data-rd-motion-toggle]',viewport.parentElement);
      if(!group?.children.length){if(button)button.hidden=true;return;}
      const clone=group.cloneNode(true);clone.setAttribute('data-rd-marquee-clone','');clone.removeAttribute('data-rd-marquee-group');clone.setAttribute('aria-hidden','true');
      all('[data-shopify-editor-block],[id]',clone).forEach(el=>{el.removeAttribute('data-shopify-editor-block');el.removeAttribute('id');});all('a,button',clone).forEach(el=>el.tabIndex=-1);track.append(clone);
      let paused=false,visible=false;
      const update=()=>{viewport.dataset.running=String(!paused&&!reduced.matches&&visible&&!document.hidden);if(button){button.dataset.paused=String(paused||reduced.matches);button.setAttribute('aria-label',button.dataset[paused||reduced.matches?'playLabel':'pauseLabel']);}};
      const measure=()=>{group.style.minWidth=`${viewport.clientWidth}px`;clone.style.minWidth=group.style.minWidth;viewport.style.setProperty('--rd-marquee-duration',`${Math.max(18,group.getBoundingClientRect().width/36)}s`);};
      const resize=new ResizeObserver(measure);resize.observe(viewport);resize.observe(group);
      const intersection=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;update();});intersection.observe(viewport);
      button?.addEventListener('click',()=>{paused=!paused;update();});
      document.addEventListener('visibilitychange',update);reduced.addEventListener('change',update);measure();update();
      viewport._cleanup=()=>{resize.disconnect();intersection.disconnect();document.removeEventListener('visibilitychange',update);reduced.removeEventListener('change',update);};
    });
  }
  function initStats(root=document) {
    all('[data-rd-stats]',root).forEach(section=>{
      if(section.dataset.ready)return;section.dataset.ready='true';
      const values=all('.rd-stats__value',section).map(el=>{
        const text=el.textContent.trim(),accessible=document.createElement('span'),measure=document.createElement('span'),visual=document.createElement('span');
        accessible.className='visually-hidden';accessible.textContent=text;
        measure.className='rd-stats__measure';measure.textContent=text;measure.setAttribute('aria-hidden','true');visual.setAttribute('aria-hidden','true');visual.textContent=text;
        el.replaceChildren(accessible,measure,visual);return {text,visual};
      });
      const paint=progress=>values.forEach(({text,visual})=>{
        visual.textContent=progress===1?text:text.replace(/\d+(?:[.,]\d+)?/g,(number,offset)=>{
          // A rating's scale (e.g. /5) stays fixed; only the rating counts up.
          if(text.slice(0,offset).trimEnd().endsWith('/'))return number;
          const decimals=number.match(/[.,](\d+)/)?.[1].length||0;
          const value=(Number(number.replace(',','.'))*progress).toFixed(decimals);
          return number.includes(',')?value.replace('.',','):value;
        });
      });
      let frame,started=false;
      const finish=()=>{cancelAnimationFrame(frame);paint(1);};
      const observer=new IntersectionObserver(entries=>{
        if(started||!entries.some(entry=>entry.isIntersecting))return;
        started=true;observer.disconnect();
        if(reduced.matches){finish();return;}
        const start=performance.now();
        const tick=now=>{const progress=Math.min(1,(now-start)/1100);paint(1-Math.pow(1-progress,3));if(progress<1)frame=requestAnimationFrame(tick);};
        frame=requestAnimationFrame(tick);
      },{threshold:.25});
      if(!reduced.matches)paint(0);observer.observe(section);
      const onMotion=()=>{if(reduced.matches)finish();};reduced.addEventListener('change',onMotion);
      section._cleanup=()=>{observer.disconnect();cancelAnimationFrame(frame);reduced.removeEventListener('change',onMotion);};
    });
  }
  function initPurchase(root=document) {
    all('.alpe-pdp-redesign[data-section-type="product-template"]',root).forEach(section=>{
      if(section.dataset.rdPurchaseReady || !qs('[data-current-variant-json]',section))return;
      section.dataset.rdPurchaseReady='true';
      const original=qs('[data-add-to-cart]',section),form=original?.form;
      if(!original||!form)return;
      const variants=JSON.parse(qs('[data-variant-json]',section).value);
      let variant=variants.find(item=>String(item.id)===qs('[data-product-select]',section)?.value)||JSON.parse(qs('[data-current-variant-json]',section).value);
      const bar=document.createElement('div');bar.className='rd-sticky-purchase';
      const summary=document.createElement('div');summary.className='rd-sticky-purchase__summary';
      const price=document.createElement('p'),option=document.createElement('p');option.className='rd-sticky-purchase__variant';
      price.className='rd-sticky-purchase__price';
      const compare=document.createElement('s'),current=document.createElement('span');
      const regularLabel=document.createElement('span'),saleLabel=document.createElement('span');
      regularLabel.className=saleLabel.className='visually-hidden';
      regularLabel.textContent=qs('[data-price-a11y]',section)?.textContent.trim()||'';
      saleLabel.textContent=qs('[data-compare-a11y]',section)?.textContent.trim()||'';
      compare.className='rd-sticky-purchase__compare';
      price.append(regularLabel,compare,saleLabel,current);
      const button=document.createElement('button');button.type='button';button.className='btn';
      summary.append(price,option);bar.append(summary,button);section.append(bar);
      let target=original,frame;
      const update=()=>{
        const stock=qs('[data-alpe-size-stock-cta]',section),bundle=qs('[data-alpe-pdp-bundle-submit]',section);
        target=stock&&!stock.hidden?stock:bundle&&!bundle.hidden?bundle:original;
        const label=target.textContent.trim();if(button.textContent!==label)button.textContent=label;
        button.disabled=target.disabled||target.classList.contains('btn--loading');
        if(variant){
          const onSale=variant.compare_at_price>variant.price;
          const priceKey=`${variant.price}:${variant.compare_at_price||0}`;
          if(price.dataset.amount!==priceKey){
            current.innerHTML=theme.Currency.formatMoney(variant.price,theme.settings.moneyFormat);
            current.classList.toggle('sale-price',onSale);
            compare.hidden=saleLabel.hidden=!onSale;
            compare.innerHTML=onSale?theme.Currency.formatMoney(variant.compare_at_price,theme.settings.moneyFormat):'';
            price.dataset.amount=priceKey;
          }
          regularLabel.hidden=false;
          const title=variant.title==='Default Title'?'':variant.title;if(option.textContent!==title)option.textContent=title;
        }else{current.textContent=compare.textContent='';regularLabel.hidden=saleLabel.hidden=compare.hidden=true;current.classList.remove('sale-price');delete price.dataset.amount;option.textContent='';}
        all('[data-rd-delivery]',section).forEach(el=>el.hidden=!variant?.available);
        const rect=target.getBoundingClientRect(),header=qs('.rd-header__bar')?.getBoundingClientRect().bottom||0;
        const visible=rect.bottom>header&&rect.top<innerHeight;
        bar.classList.toggle('is-visible',window.scrollY>180&&!visible);
        frame=null;
      };
      const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
      button.addEventListener('click',()=>{
        if(target.disabled)return;
        if(target===original)form.requestSubmit(original);else target.click();
      });
      const onVariant=e=>{variant=e.detail?.variant||null;schedule();};section.addEventListener('variantChange',onVariant);
      const observer=new MutationObserver(schedule);
      [original,qs('[data-alpe-size-stock-cta]',section),qs('[data-alpe-pdp-bundle-submit]',section)].filter(Boolean).forEach(el=>observer.observe(el,{attributes:true,childList:true,subtree:true}));
      const intersection=new IntersectionObserver(schedule);intersection.observe(original);
      window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule);update();
      section._cleanup=()=>{observer.disconnect();intersection.disconnect();cancelAnimationFrame(frame);section.removeEventListener('variantChange',onVariant);window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);};
    });
  }
  function initReveal(root = document) {
    all('[data-rd-reveal]', root).forEach(el => {
      if (el.dataset.ready) return;
      el.dataset.ready = 'true';
      const text = el.textContent.trim();
      el.removeAttribute('aria-label');
      el.replaceChildren(...text.split(/(\s+)/).map(word => {
        if (!word.trim()) return document.createTextNode(word);
        const span = document.createElement('span');
        span.className = 'rd-word'; span.textContent = word; span.setAttribute('aria-hidden', 'true'); return span;
      }));
      const accessible=document.createElement('span');accessible.className='visually-hidden';accessible.textContent=text;el.prepend(accessible);
      const words = all('.rd-word', el);
      let scheduled = false;
      const paint = () => {
        const rect = el.getBoundingClientRect();
        const travel = innerHeight / 2 + rect.height / 2;
        const progress = Math.max(0, Math.min(1, (innerHeight - rect.top) / travel));
        words.forEach((word, i) => {
          const ratio = reduced.matches ? 1 : Math.max(0, Math.min(1, progress * words.length - i));
          const channel = Math.round(166 * (1-ratio));
          word.style.color = `rgb(${channel},${channel},${channel})`;
        });
        scheduled = false;
      };
      const update = () => {if (!scheduled) {scheduled = true;requestAnimationFrame(paint);}};
      window.addEventListener('scroll', update, {passive:true});
      window.addEventListener('resize', update);reduced.addEventListener('change', update);paint();
    });
  }
  function initCarousels(root = document) {
    all('[data-rd-carousel]', root).forEach(el => {
      if (el.dataset.ready || el._rdCarouselPending) return;
      let observer;
      const initialize = () => {
      observer?.disconnect();
      delete el._rdCarouselPending;
      if (el.dataset.ready || !el.isConnected) return;
      el.dataset.ready = 'true';
      const track = qs('[data-rd-track]',el);
      if (!track) return;
      let loopSpan=0;
      if(el.hasAttribute('data-rd-loop') && track.children.length>1){
        const original=[...track.children];
        const clone=card=>{const copy=card.cloneNode(true);copy.removeAttribute('data-shopify-editor-block');copy.setAttribute('aria-hidden','true');copy.querySelectorAll('[id]').forEach(x=>x.removeAttribute('id'));copy.querySelectorAll('a,button,video').forEach(x=>x.tabIndex=-1);return copy;};
        track.prepend(...original.map(clone));track.append(...original.map(clone));
        const measureLoop=()=>{loopSpan=original[0].offsetLeft-track.firstElementChild.offsetLeft;track.scrollTo({left:loopSpan,behavior:'instant'});};
        measureLoop();
        const recenter=()=>{if(track.scrollLeft<loopSpan-2)track.scrollTo({left:track.scrollLeft+loopSpan,behavior:'instant'});else if(track.scrollLeft>=loopSpan*2-2)track.scrollTo({left:track.scrollLeft-loopSpan,behavior:'instant'});};
        track.addEventListener('scrollend',recenter);let settle;
        track.addEventListener('scroll',()=>{clearTimeout(settle);settle=setTimeout(recenter,180);},{passive:true});
        new ResizeObserver(measureLoop).observe(el);
      }
      const prev = qs('[data-rd-prev]',el), next = qs('[data-rd-next]',el);
      const update = () => {if (!el.hasAttribute('data-rd-loop')) {if(prev)prev.disabled=track.scrollLeft<2;if(next)next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;}};
      const move = direction => {
        const step = (track.firstElementChild?.getBoundingClientRect().width || track.clientWidth) + 15;
        const max = track.scrollWidth - track.clientWidth;
        let target = track.scrollLeft + step * direction;
        if (!loopSpan && el.hasAttribute('data-rd-loop')) {if(target>max+3)target=0;if(target< -3)target=max;}
        track.scrollTo({left:target,behavior:behavior()});
      };
      prev?.addEventListener('click',()=>move(-1));next?.addEventListener('click',()=>move(1));
      track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);update();
      all('video',el).forEach(video=>video.addEventListener('play',()=>all('video',document).forEach(other=>{if(other!==video)other.pause();})));
      let startX = 0, startLeft = 0;
      track.addEventListener('touchstart', e => {startX=e.touches[0].clientX;startLeft=track.scrollLeft;},{passive:true});
      track.addEventListener('touchend', e => {
        if(loopSpan||!el.hasAttribute('data-rd-loop'))return;
        const delta = e.changedTouches[0].clientX-startX,max=track.scrollWidth-track.clientWidth;
        if(Math.abs(delta)<60)return;
        if(startLeft>=max-3&&delta<0)track.scrollTo({left:0,behavior:behavior()});
        else if(startLeft<=3&&delta>0)track.scrollTo({left:max,behavior:behavior()});
      },{passive:true});
      initReviewVideos(el);
      };
      if (el.hasAttribute('data-rd-loop') && !window.Shopify?.designMode && 'IntersectionObserver' in window && el.getBoundingClientRect().top > innerHeight + 600) {
        el._rdCarouselPending = true;
        observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) initialize();
        }, {rootMargin: '600px 0px'});
        observer.observe(el);
        el.addEventListener('focusin', initialize, {once: true});
        el.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => observer.disconnect(), {once: true});
      } else {
        initialize();
      }
    });
  }
  function initReviewVideos(root = document) {
    const videos = all('video[data-rd-video-poster]', root).filter(video => !video._rdPosterReady);
    if (!videos.length) return;
    let observer;
    const activate = video => {
      const poster = video.dataset.rdVideoPoster;
      if (poster) {
        video.poster = poster;
        delete video.dataset.rdVideoPoster;
      }
      observer?.unobserve(video);
    };
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.isIntersecting) activate(entry.target); });
      }, {rootMargin: '600px 200px'});
    }
    videos.forEach(video => {
      video._rdPosterReady = true;
      video.addEventListener('pointerdown', () => activate(video), {once: true, passive: true});
      video.addEventListener('focus', () => activate(video), {once: true});
      if (observer) observer.observe(video); else activate(video);
    });
    if (observer) {
      const section = videos[0].closest('.shopify-section');
      section?.addEventListener('shopify:section:unload', () => observer.disconnect(), {once: true});
    }
  }
  function initSales(root = document) {
    all('[data-rd-sale]', root).forEach(el => {
      if (el.dataset.ready) return;
      el.dataset.ready = 'true';
      const owner = el.closest('[data-section-type="product-template"], [data-alpe-product-scope]');
      const variantsData = owner && qs('[data-variant-json]', owner);
      const selectedId = owner && qs('[data-product-select]', owner)?.value;
      let variant = (variantsData && JSON.parse(variantsData.value).find(item => String(item.id) === selectedId))
        || JSON.parse(qs('[data-rd-variant]', el).textContent);
      const saving = qs('[data-rd-saving]', el), countdown = qs('[data-rd-countdown]', el), time = qs('time', el);
      // Liquid converts the product's date_time to an epoch, independent of visitor timezone.
      const deadline = Number(el.dataset.end);
      const accessible = document.createElement('span'), visual = document.createElement('span');
      const measures = ['percent', 'amount'].map(() => {
        const measure = document.createElement('span');
        measure.className = 'rd-saving-measure'; measure.setAttribute('aria-hidden', 'true');
        return measure;
      });
      accessible.className = 'visually-hidden';
      visual.className = 'rd-saving-visual'; visual.setAttribute('aria-hidden', 'true');
      // Both invisible labels share the same grid cell, reserving the wider state.
      saving.replaceChildren(accessible, ...measures, visual);
      const initialMode = el.dataset.format === 'amount' ? 'amount' : 'percent';
      const money = new Intl.NumberFormat(document.documentElement.lang || 'sl-SI', {
        style: 'currency', currency: el.dataset.currency || 'EUR'
      });
      let visible = false, frame, repeat, mode = initialMode, savingKey = '';
      let targets = {percent: 0, amount: 0};
      const format = (value, kind = mode) => kind === 'amount'
        ? money.format(Math.round(value) / 100)
        : `${Math.round(value)} %`;
      const label = kind => `${format(targets[kind], kind)} ${el.dataset.saveLabel}`;
      const paint = value => { visual.textContent = `${format(value)} ${el.dataset.saveLabel}`; };
      const stop = () => { cancelAnimationFrame(frame); clearTimeout(repeat); paint(targets[mode]); };
      const animate = () => {
        stop();
        if (!targets.amount || !visible || document.hidden) return;
        const next = () => {
          // Five full seconds to read the settled value, after the count-up finishes.
          repeat = setTimeout(() => { mode = mode === 'percent' ? 'amount' : 'percent'; animate(); }, 5000);
        };
        if (reduced.matches) { next(); return; }
        const start = performance.now(); paint(0);
        const tick = now => {
          const progress = Math.min(1, (now - start) / 1100);
          paint(targets[mode] * (1 - Math.pow(1 - progress, 3)));
          if (progress < 1) frame = requestAnimationFrame(tick);
          else next();
        };
        frame = requestAnimationFrame(tick);
      };
      const render = () => {
        clearTimeout(el._timer);
        const sale = !!variant && variant.compare_at_price > variant.price;
        el.hidden = saving.hidden = !sale;
        const key = sale ? `${variant.price}:${variant.compare_at_price}` : '';
        if (key !== savingKey) {
          savingKey = key;
          const amount = sale ? variant.compare_at_price - variant.price : 0;
          targets = {amount, percent: sale ? Math.round(amount / variant.compare_at_price * 100) : 0};
          mode = initialMode;
          // Screen readers get both final values once, never the changing count-up.
          accessible.textContent = `${format(targets.percent, 'percent')} / ${label('amount')}`;
          measures[0].textContent = label('percent'); measures[1].textContent = label('amount');
          animate();
        }
        const now = Date.now();
        const remaining = deadline - now;
        countdown.hidden = !(sale && Number.isFinite(deadline) && deadline > 0 && remaining > 0);
        if (countdown.hidden) return;
        time.dateTime = new Date(deadline).toISOString();
        time.textContent = countdownRemaining(deadline, now, el.dataset);
        // Tick once per second, and hide at expiry even between second boundaries.
        if (!document.hidden) el._timer = setTimeout(render, Math.min(remaining, 1000 - now % 1000 + 10));
      };
      const onVariant = event => { variant = event.detail?.variant || null; render(); };
      const onVisibility = () => { render(); animate(); };
      owner?.addEventListener('variantChange', onVariant);
      const intersection = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; animate(); }, {threshold: .5});
      intersection.observe(saving);
      document.addEventListener('visibilitychange', onVisibility); reduced.addEventListener('change', animate);
      el._cleanup = () => {
        clearTimeout(el._timer); stop(); intersection.disconnect();
        owner?.removeEventListener('variantChange', onVariant);
        document.removeEventListener('visibilitychange', onVisibility); reduced.removeEventListener('change', animate);
      };
      render();
    });
  }
  const normalizeSize=value=>String(value||'').trim().toUpperCase().replace(/^2XL$/,'XXL').replace(/^XXXL$/,'3XL');
  const normalizeWords=value=>String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  function searchWords(value) {
    const stem = word => {
      if (/^(men|mens|male)$/.test(word)) return 'mosk';
      if (/^(women|womens|female)$/.test(word)) return 'zensk';
      return word.match(/^(mosk|zensk|kolesarsk|zimsk|poletn|kratk|dolg|hlac|dres|jakn|rokavic|nogavic|rokavck|nogavck|brezrokavnik|grelnik)/)?.[0] || word;
    };
    return (normalizeWords(value).match(/[\p{L}\p{N}]+/gu) || []).map(stem);
  }
  function searchWordMatches(term, word) {
    if (term === word || (term.length > 1 && word.startsWith(term))) return true;
    if (term.length < 5 || term.slice(0,4) !== word.slice(0,4) || Math.abs(term.length - word.length) > 1) return false;
    let a = 0, b = 0, edits = 0;
    while (a < term.length && b < word.length) {
      if (term[a] === word[b]) { a++; b++; continue; }
      if (++edits > 1) return false;
      if (term.length === word.length && term[a] === word[b+1] && term[a+1] === word[b]) { a += 2; b += 2; }
      else if (term.length === word.length) { a++; b++; }
      else if (term.length > word.length) a++;
      else b++;
    }
    return edits + (term.length - a) + (word.length - b) <= 1;
  }
  function searchRelevant(terms, node) {
    if (!terms?.trim()) return true;
    const query = searchWords(terms).filter(word => !/^(za|in|z|s|na|od|do|the|for|and|with)$/.test(word));
    if (!query.length) return false;
    const words = searchWords([node.dataset.rdTitle, node.dataset.rdType, node.dataset.rdTags, node.dataset.rdSearchVariants].filter(Boolean).join(' '));
    return query.every(term => words.some(word => searchWordMatches(term, word)) || ((term === 'mosk' || term === 'zensk') && words.includes('unisex')));
  }
  window.AlpeSearch = {matches: searchRelevant};
  const localKeys=['gender','type','size','line','color'];
  const localChoices={gender:['Moški','Ženski'],type:['Dres','Hlače','Jakna','Brezrokavnik','Dodatki','Rokavice','Nogavice','Nogavčki','Rokavčki'],line:['3F','V1','Minimalist','Diagonala','Flow','Krvavec','Pro']};
  function initLocalFilters(root=document,url=location.href){
    const section=root.matches?.('[data-rd-collection]')?root:qs('[data-rd-collection]',root);if(!section)return;
    const host=qs('[data-rd-local-filters]',section);if(!host)return;
    const cards=all('.rd-product-grid>.rd-card',section);
    cards.forEach(card=>{card._tags=JSON.parse(card.dataset.rdTags||'[]');const options=JSON.parse(card.dataset.rdOptions||'[]');card._availableSizes=JSON.parse(card.dataset.rdAvailableOptions||'[]').map(o=>normalizeSize(o[options.findIndex(x=>/size|velikost/i.test(x.name))]));card._sizes=options.filter(o=>/size|velikost/i.test(o.name)).flatMap(o=>o.values.map(v=>normalizeSize(typeof v==='string'?v:v.name)));});
    const sizes=[...new Set(cards.flatMap(c=>c._sizes))];const order=['XXS','XS','S','M','L','XL','XXL','3XL'];sizes.sort((a,b)=>(order.includes(a)?order.indexOf(a):99)-(order.includes(b)?order.indexOf(b):99)||a.localeCompare(b));
    for(const group of ['gender','type','size','line']){
      const container=qs(`[data-rd-options="${group}"]`,host);container.replaceChildren();
      const configured=group==='line'?section.dataset.filterLines:group==='type'?section.dataset.filterTypes:'';const values=group==='size'?sizes:configured?configured.split(',').map(x=>x.trim()).filter(Boolean):localChoices[group];
      values.forEach(value=>{const label=document.createElement('label');label.className='rd-filter-option';const input=document.createElement('input');input.type='checkbox';input.name=`alpe.${group}`;input.value=value;const span=document.createElement('span');span.textContent=group==='size'&&value==='XXL'?'2XL / XXL':value;const small=document.createElement('small');span.append(small);label.append(input,span);container.append(label);});
    }
    host.hidden=false;
    const params=new URL(url,location.origin).searchParams;
    all('input[name^="alpe."]',host).forEach(input=>input.checked=params.getAll(input.name).map(v=>input.name==='alpe.size'?normalizeSize(v):v).includes(input.value));
    section.dataset.loadedUrl=url;
    applyLocalFilters(section,url);
  }
  function applyLocalFilters(section,url=location.href){
    const host=qs('[data-rd-local-filters]',section),cards=all('.rd-product-grid>.rd-card',section);
    const inputs=all('input[name^="alpe."]',host),params=new URL(url,location.origin).searchParams;
    const chosen=Object.fromEntries(localKeys.map(k=>[k,params.getAll(`alpe.${k}`).map(v=>k==='size'?normalizeSize(v):v)]));
    const matches=(card,key,value)=>{
      if(key==='size')return (params.getAll('filter.v.availability').includes('1')&&!params.getAll('filter.v.availability').includes('0')?card._availableSizes:card._sizes).includes(value);
      if(key==='color'){const input=inputs.find(i=>i.name==='alpe.color'&&i.value===value);return input?.dataset.rdColorHandles.split(',').includes(card.dataset.rdHandle);}
      if(key==='line'&&value==='Pro')return /\bPro\b/.test(card.dataset.rdTitle);
      return card._tags.includes(value);
    };
    const relevance = new Map(cards.map(card => [card, searchRelevant(section.dataset.searchTerms, card)]));
    const relevant = card => relevance.get(card);
    const included=(card,except)=>relevant(card)&&localKeys.every(key=>key===except||!chosen[key].length||chosen[key].some(value=>matches(card,key,value)));
    cards.forEach(card=>card.hidden=!included(card));
    const count=cards.filter(c=>!c.hidden).length;
    const status=qs('[role=status]',section);if(status)status.textContent=(section.dataset['count'+({one:'One',two:'Two',few:'Few',other:'Other'}[new Intl.PluralRules(document.documentElement.lang).select(count)])]||section.dataset.countLabel).replace('__COUNT__',count);
    const done=qs('.rd-filters__done',section);if(done)done.textContent=section.dataset.doneLabel.replace('__COUNT__',count);
    const empty=qs('[data-rd-local-empty]',section);if(empty)empty.hidden=count!==0||cards.length===0;
    inputs.forEach(input=>{const key=input.name.slice(5),n=cards.filter(c=>included(c,key)&&matches(c,key,input.value)).length;input.disabled=n===0&&!input.checked;input.closest('label').classList.toggle('rd-disabled',input.disabled);qs('small',input.closest('label')).textContent=n;});
    all('[data-rd-filter-group]',host).forEach(group=>{group.hidden=!all('input',group).some(i=>!i.disabled||i.checked);});
    // Shopify's filter links omit custom parameters. Preserve the other selections.
    all('.rd-active-filters > a,.rd-pagination a',section).forEach(link=>{
      const target=new URL(link.href,location.origin);
      localKeys.forEach(key=>{const name=`alpe.${key}`;target.searchParams.delete(name);params.getAll(name).forEach(value=>target.searchParams.append(name,value));});
      link.href=target.pathname+target.search;
    });
    const active=qs('[data-rd-local-active]',section);active.replaceChildren();
    inputs.filter(i=>i.checked).forEach(input=>{const chip=document.createElement('a'),target=new URL(url,location.origin);if(input.name==='alpe.size'){const keep=target.searchParams.getAll(input.name).filter(v=>normalizeSize(v)!==input.value);target.searchParams.delete(input.name);keep.forEach(v=>target.searchParams.append(input.name,v));}else target.searchParams.delete(input.name,input.value);chip.href=target.pathname+target.search;chip.setAttribute('data-rd-filter-link','');chip.textContent=`${[...input.closest('label').querySelector('span').childNodes].filter(n=>n.nodeType===3).map(n=>n.textContent).join('').trim()||input.value} ×`;active.append(chip);});
    const hasFilters=[...params.keys()].some(key=>key.startsWith('filter.')||key.startsWith('alpe.'));
    all('.rd-clear,[data-rd-empty-clear]',section).forEach(clear=>clear.hidden=!hasFilters);
    if(section.hasAttribute('data-rd-search-page')){section.classList.toggle('rd-search-empty',count===0&&!hasFilters);const toggle=qs('[data-rd-filters-open]',section);if(toggle)toggle.hidden=count===0&&!hasFilters;}
    const localEmpty=qs('[data-rd-local-empty]',section);
    if(localEmpty&&section.hasAttribute('data-rd-search-page'))all('[data-rd-filter-link]',localEmpty).forEach(link=>link.hidden=!hasFilters);
  }

  function revealResults(section) {
    if(qs('.rd-filters.is-open',section))return;
    const results=qs('.rd-collection-results',section),toolbar=qs('.rd-collection-toolbar',section);
    if(!results||!toolbar)return;
    const bounds=results.getBoundingClientRect(),header=Math.max(0,qs('.rd-header')?.getBoundingClientRect().bottom||0);
    if(bounds.bottom<header+120||bounds.top>innerHeight-100)toolbar.scrollIntoView({behavior:behavior(),block:'start'});
  }

  let filterController;
  async function replaceCollection(url, push=true) {
    const current=qs('[data-rd-collection]');if(!current)return;
    if(push)saveListingPosition();
    const before=new URL(current.dataset.loadedUrl||location.href,location.origin),after=new URL(url,location.origin);
    const serverPart=u=>{const copy=new URL(u);for(const key of ['filter.v.price.gte','filter.v.price.lte']){if(copy.searchParams.has(key))copy.searchParams.set(key,String(Number(copy.searchParams.get(key))));}localKeys.forEach(k=>copy.searchParams.delete(`alpe.${k}`));if(copy.searchParams.get('sort_by')===current.dataset.defaultSort)copy.searchParams.delete('sort_by');return copy.pathname+copy.search;};
    filterController?.abort();
    if(serverPart(before)===serverPart(after)){if(push)history.pushState({rdFilters:true,rdScroll:window.scrollY},'',url);all('input[name^="alpe."]',current).forEach(i=>i.checked=after.searchParams.getAll(i.name).map(v=>i.name==='alpe.size'?normalizeSize(v):v).includes(i.value));applyLocalFilters(current,url);current.dataset.loadedUrl=url;if(push)revealResults(current);if(!reduced.matches)qs('.rd-product-grid',current)?.animate([{opacity:.35},{opacity:1}],{duration:250,easing:'ease-out'});return;}
    filterController=new AbortController();
    const active=qs('.rd-filters.is-open',current),scrollTop=active?.scrollTop||0;
    const focus=document.activeElement,focusName=focus?.name,focusValue=focus?.value;
    const requestUrl=new URL(url,location.origin);requestUrl.searchParams.set('section_id',current.dataset.section);
    current.setAttribute('aria-busy','true');
    try {
      const response=await fetch(requestUrl,{signal:filterController.signal});if(!response.ok)throw new Error('request');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const fresh=qs('[data-rd-collection]',doc);if(!fresh)throw new Error('section');
      const selectedDetails=all('.rd-filters details',current).map(d=>d.open);
      all('.rd-filters details',fresh).forEach((d,i)=>{if(selectedDetails[i]!==undefined)d.open=selectedDetails[i];});
      current.replaceWith(fresh);
      initLocalFilters(fresh,url);
      if(push)history.pushState({rdFilters:true,rdScroll:window.scrollY},'',url);
      if(active?.classList.contains('is-open')){qs('[data-rd-filters-open]',fresh).setAttribute('aria-expanded','true');qs('.rd-filters',fresh).classList.add('is-open');qs('.rd-filters',fresh).setAttribute('role','dialog');qs('.rd-filters',fresh).setAttribute('aria-modal','true');qs('.rd-filter-backdrop',fresh).hidden=false;qs('.rd-filters',fresh).scrollTop=scrollTop;}
      if(focusName){all('input',fresh).find(i=>i.name===focusName&&i.value===focusValue&&i.getClientRects().length)?.focus({preventScroll:true});}
      if(focus?.closest('.rd-pagination')){qs('.rd-collection-toolbar',fresh).scrollIntoView({behavior:behavior(),block:'start'});}
      if(push)revealResults(fresh);
      if(!reduced.matches)qs('.rd-product-grid',fresh)?.animate([{opacity:.25,transform:'translateY(6px)'},{opacity:1,transform:'translateY(0)'}],{duration:250,easing:'ease-out'});
    }catch(error){if(error.name!=='AbortError')location.href=url;}
    finally{current.removeAttribute('aria-busy');}
  }
  function filterUrl(form){const url=new URL(form.action,location.origin);url.search='';const data=new FormData(form);for(const [key,value]of data)if(value!=='')url.searchParams.append(key,value);const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);return url.pathname+url.search;}
  let priceTimer;
  document.addEventListener('input',e=>{const form=e.target.closest('[data-rd-filter-form]');if(!form||e.target.type!=='number')return;clearTimeout(priceTimer);priceTimer=setTimeout(()=>{if(form.isConnected&&form.checkValidity())replaceCollection(filterUrl(form));},500);});
  document.addEventListener('change',e=>{const form=e.target.closest('[data-rd-filter-form]');if(form){clearTimeout(priceTimer);if(form.checkValidity())replaceCollection(filterUrl(form));}});
  document.addEventListener('submit',e=>{if(e.target.matches('[data-rd-filter-form]')){e.preventDefault();clearTimeout(priceTimer);if(e.target.checkValidity())replaceCollection(filterUrl(e.target));}});
  function saveListingPosition(){if(qs('[data-rd-collection]'))history.replaceState({...history.state,rdScroll:window.scrollY},'');}
  window.addEventListener('pagehide',saveListingPosition);
  document.addEventListener('click',e=>{
    const link=e.target.closest('.rd-product-grid .rd-card a[href]');
    if(link&&qs('[data-rd-collection]')){saveListingPosition();try{sessionStorage.setItem('alpe:listing-context',JSON.stringify({url:location.href,y:scrollY,product:new URL(link.href).pathname,time:Date.now()}));}catch{}}
    const back=e.target.closest('.alpe-breadcrumbs__back[data-rd-listing-return]');
    if(back){try{sessionStorage.setItem('alpe:listing-return',back.dataset.rdListingReturn);}catch{}}
  },true);
  function initListingReturn(){
    try{
      const context=JSON.parse(sessionStorage.getItem('alpe:listing-context')||'null');
      if(!context||Date.now()-context.time>7200000||context.product!==location.pathname)return;
      const target=new URL(context.url),back=qs('.alpe-breadcrumbs--product .alpe-breadcrumbs__back');
      if(!back||target.origin!==location.origin||!/(?:^|\/)(collections|search)(?:\/|$)/.test(target.pathname))return;
      back.href=target.href;back.dataset.rdListingReturn=JSON.stringify(context);
    }catch{}
  }
  window.addEventListener('pageshow',()=>{
    if(!qs('[data-rd-collection]'))return;
    try{const pending=JSON.parse(sessionStorage.getItem('alpe:listing-return')||'null');if(pending?.url===location.href&&Number.isFinite(pending.y)){sessionStorage.removeItem('alpe:listing-return');requestAnimationFrame(()=>window.scrollTo({top:pending.y,behavior:'instant'}));}}catch{}
  });
  window.addEventListener('pageshow',e=>{if(!qs('[data-rd-collection]'))return;if((e.persisted||performance.getEntriesByType('navigation')[0]?.type==='back_forward')&&Number.isFinite(history.state?.rdScroll)){const y=history.state.rdScroll;requestAnimationFrame(()=>window.scrollTo({top:y,behavior:'instant'}));}});
  window.addEventListener('popstate',async e=>{if(qs('[data-rd-collection]')){const y=e.state?.rdScroll;await replaceCollection(location.href,false);if(Number.isFinite(y))window.scrollTo({top:y,behavior:'instant'});}});
  document.addEventListener('click',e=>{
    const cartLink=e.target.closest('[data-rd-cart-open]');
    if(cartLink && window.theme?.settings.cartType === 'drawer' && window.theme.cartDrawer){
      if(e.button!==0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)return;
      e.preventDefault();
      e.stopPropagation();
      const trigger=cartLink.closest('dialog')?qs('.rd-header__actions [data-rd-cart-open]'):cartLink;
      closeDialog(qs('.rd-menu[open]'),false).then(()=>{
        theme.cartDrawer.drawer.open(null,trigger);
        theme.cartDrawer.cartForm.buildCart();
      });
      return;
    }
    const opener=e.target.closest('[data-rd-menu-open]');
    if(opener?.matches('a[href]'))return;
    if(opener){const h=opener.closest('[data-rd-header]'),d=qs('.rd-menu',h);all('[data-rd-menu-category]',d).forEach(x=>x.open=x.dataset.rdMenuCategory===opener.dataset.rdCategory);openDialog(d,opener);return;}
    const search=e.target.closest('[data-rd-search-open]');if(search){e.preventDefault();closeDialog(qs('.rd-menu[open]'),false).then(()=>{if(nativeSearch){nativeSearch._trigger=search.closest('dialog')?qs('.rd-header__actions [data-rd-search-open]'):search;search.setAttribute('aria-expanded','true');nativeSearch.open();}else location.href=window.theme?.routes?.search||'/search';});return;}
    const close=e.target.closest('[data-rd-close]');if(close){closeDialog(close.closest('dialog'));return;}
    const link=e.target.closest('[data-rd-filter-link],.rd-pagination a');if(link){e.preventDefault();replaceCollection(link.href);return;}
    const filterOpen=e.target.closest('[data-rd-filters-open]');if(filterOpen){const section=filterOpen.closest('[data-rd-collection]'),panel=qs('.rd-filters',section);panel.classList.add('is-open');panel.setAttribute('role','dialog');panel.setAttribute('aria-modal','true');filterOpen.setAttribute('aria-expanded','true');qs('.rd-filter-backdrop',section).hidden=false;qs('button',panel).focus();return;}
    const filterClose=e.target.closest('[data-rd-filters-close]');if(filterClose){const section=filterClose.closest('[data-rd-collection]'),panel=qs('.rd-filters',section);panel.classList.remove('is-open');panel.removeAttribute('role');panel.removeAttribute('aria-modal');qs('.rd-filter-backdrop',section).hidden=true;const toggle=qs('[data-rd-filters-open]',section);toggle?.setAttribute('aria-expanded','false');toggle?.focus({preventScroll:true});revealResults(section);return;}
    const videoToggle=e.target.closest('[data-rd-video-toggle]');if(videoToggle){const video=qs('video',videoToggle.closest('.rd-hero'));if(video.paused){video.play();videoToggle.textContent=videoToggle.dataset.pauseLabel;}else{video.pause();videoToggle.textContent=videoToggle.dataset.playLabel;}}
  });
  document.addEventListener('keydown',e=>{
    const panel=qs('.rd-filters.is-open');if(!panel)return;
    if(e.key==='Escape'){qs('[data-rd-filters-close]',panel).click();return;}
    if(e.key==='Tab'){const items=all('button,a[href],input:not([disabled]),summary',panel).filter(x=>x.getClientRects().length);const first=items[0],last=items.at(-1);if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}}
  });
  function celebrateShipping(el){
    if(reduced.matches)return;
    clearTimeout(el._rewardTimer);
    el.classList.remove('is-celebrating');void el.offsetWidth;
    el.classList.add('is-celebrating');
    el._rewardTimer=setTimeout(()=>el.classList.remove('is-celebrating'),2000);
  }
  function updateShipping(cart){
    if(!Number.isFinite(cart?.total_price))return;
    all('[data-rd-topbar]').forEach(el=>el._updateCart?.(cart));
    all('[data-cart-shipping]').forEach(el=>{
      const total=Math.max(0,cart.total_price),threshold=Number(el.dataset.threshold),remaining=Math.max(0,threshold-total);
      if(!(threshold>0))return;
      const earned=remaining===0;
      const newlyEarned=earned && Number(el.dataset.total)<threshold;
      const amount=new Intl.NumberFormat(document.documentElement.lang||'sl-SI',{style:'currency',currency:'EUR',minimumFractionDigits:remaining%100?2:0}).format(remaining/100);
      const pending=qs('[data-cart-shipping-pending]',el),unlocked=qs('[data-cart-shipping-earned]',el);
      qs('[data-cart-shipping-amount]',el).textContent=amount;
      pending.hidden=earned;unlocked.hidden=!earned;el.classList.toggle('is-earned',earned);
      const bar=qs('[role=progressbar]',el);bar.setAttribute('aria-valuenow',Math.min(total,threshold));bar.setAttribute('aria-valuetext',earned?el.dataset.earnedLabel:el.dataset.remainingLabel.replace('__AMOUNT__',amount));
      qs('[data-cart-shipping-fill]',el).style.width=`${Math.min(100,total/threshold*100)}%`;
      el.dataset.total=total;
      if(!earned){
        clearTimeout(el._rewardTimer);
        el.classList.remove('is-celebrating');
      }else if(newlyEarned){celebrateShipping(el);}
    });
    all('[data-rd-shipping]').forEach(el=>{
      const threshold=Number(el.dataset.threshold),total=Math.max(0,cart.total_price),remaining=Math.max(0,threshold-total);
      const money=cents=>{const html=window.theme.Currency.formatMoney(cents,window.theme.settings.moneyFormat);const text=document.createElement('span');text.innerHTML=html;return text.textContent;};
      qs('[data-rd-shipping-message]',el).textContent=remaining>0?el.dataset.remainingLabel.replace('__AMOUNT__',money(remaining)):el.dataset.earnedLabel;
      qs('[data-rd-shipping-current]',el).textContent=el.dataset.currentLabel.replace('__AMOUNT__',money(total));
      const track=qs('[role=progressbar]',el);track.setAttribute('aria-valuenow',Math.min(total,threshold));track.setAttribute('aria-valuetext',qs('[data-rd-shipping-message]',el).textContent);qs('span',track).style.width=`${Math.min(100,total/threshold*100)}%`;el.dataset.total=total;
    });
  }
  document.addEventListener('alpe:cart-rendered',e=>updateShipping(e.detail));
  const updateCartCount=cart=>{updateShipping(cart);if(!Number.isFinite(cart?.item_count))return;all('[data-rd-cart-count]').forEach(el=>{el.textContent=cart.item_count;el.hidden=cart.item_count===0;});};
  document.addEventListener('cart:updated',e=>updateCartCount(e.detail?.cart));
  document.addEventListener('ajaxProduct:added',()=>window.theme?.cart?.getCart().then(updateCartCount).catch(()=>{}));
  const init=(root=document)=>{initTopbars(root);initHeader(root);initHeroes(root);initMarquees(root);initReveal(root);initCarousels(root);initReviewVideos(root);initSales(root);initLocalFilters(root);initStats(root);initPurchase(root);initListingReturn();all('.rd-hero video',root).forEach(v=>{if(reduced.matches)v.pause();});};
  initCategoryPress();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>{all('[data-rd-topbar],[data-rd-header],[data-rd-hero-ready],[data-rd-marquee],[data-rd-sale],[data-rd-stats],[data-rd-purchase-ready]',e.target).forEach(el=>{clearInterval(el._timer);el._resize?.disconnect();if(el._onScroll)window.removeEventListener('scroll',el._onScroll);el._cleanup?.();});});
})();

